import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-card-hsia-grid';

const html = `
<div class="container">
  <div data-attribute="card-title" data-show="true" class="card-title" style="display: block;">
    <h2>Minimizer Bra</h2>
    <p>Discover our range of minimizer bras, designed to provide the perfect fit for every body.</p>
  </div>
  <div data-attribute="list-item" class="list-item">
    <a href="#" data-attribute="item" class="item">
      <div class="wrap-img">
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab103da0173de9bae939045.webp"
          alt=""
        />
      </div> </a
    ><a href="#" data-attribute="item" class="item">
      <div class="wrap-img">
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab103decf7054aba7c6adb8.webp"
          alt=""
        />
      </div> </a
    ><a href="#" data-attribute="item" class="item">
      <div class="wrap-img">
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab103e3b74e79ab998ccd80.webp"
          alt=""
        />
      </div> </a
    ><a href="#" data-attribute="item" class="item">
      <div class="wrap-img">
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab103e79d1dd9b126bf498f.webp"
          alt=""
        />
      </div>
    </a>
  </div>
</div>
`;
export default containerFuild(html, css);
